import React from 'react';
import { useTranslation } from 'react-i18next';
import { TariffFeatures } from '../tariff-features';

export const TariffFeaturesPremiumPlus: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="flex w-full flex-1 flex-col gap-[1.6rem]">
            <TariffFeatures
                data={[
                    t('blocks.pricing.premiumPlus.features.allPremium'),
                    t('blocks.pricing.premiumPlus.features.personalAssets'),
                    t('blocks.pricing.premiumPlus.features.leaderboard'),
                    t('blocks.pricing.premiumPlus.features.insideValue'),
                    t('blocks.pricing.premiumPlus.features.priceAlert'),
                ]}
            />
        </div>
    );
};
